<template lang="pug">
  div.input-tags
    el-input.input-new-tag(
      v-if="inputVisible"
      v-model="inputValue"
      ref="saveTagInput"
      :size="GLOBAL.SIZE_OF_INPUTBOX"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm")
    el-button.button-new-tag(
      v-else
      :disabled="disabled"
      :size="GLOBAL.SIZE_OF_INPUTBOX"
      @click="showInput") + New
    el-row
      el-tag(
        v-for="(tag, index) in tagData"
        :key="index"
        closable
        :disable-transitions="false"
        @close="handleClose(tag)") {{tag}}

</template>

<script>
export default {
  props: {
    tagData: {
      props: Array,
      default: function () {
        return []
      }
    },
    disabled: { type: Boolean }
  },
  data () {
    return {
      inputVisible: false,
      inputValue: ''
    }
  },
  methods: {
    // 删除tag
    handleClose (tag) {
      this.tagData.splice(this.tagData.indexOf(tag), 1)
    },
    // 新增tag 改变tag输入状态
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    // 确认input中的tag 并且提交数据
    handleInputConfirm () {
      const inputValue = this.inputValue
      if (inputValue.trim() !== '') {
        const res = inputValue.trim().split(/[ ]+/)
        res.map(item => {
          this.tagData.push(item)
        })
        this.$emit('getData', this.tagData)
      }
      this.inputVisible = false
      this.inputValue = ''
    }
  }
}
</script>

<style lang="scss">
.input-tags {

  .button-new-tag {
    width: 100%;
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .input-new-tag {
    width: 100% !important;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .button-new-tag {
    margin: 0;
  }
}

</style>
